import React, { useState } from 'react'
import { Button, Select, SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'
import useUrlQueryParams from '../../hooks/useUrlQeryParams'
import SearchInput from '../../components/search_input'
import { CiSearch } from 'react-icons/ci'
import { IoClose } from 'react-icons/io5'
import useGetAllData from '../../hooks/useGetAllData'
import ArbitratorSearchResultCard from '../../components/search_arbitrator_card'
import { ICountries } from '../../models/countries'
import { ISpecialization } from '../../models/spetsialization'
import { IRegions } from '../../models/regions'
import { IArbitratorLanguages } from '../../models/arbitrator_languages'
import { IArbitratorAreas } from '../../models/arbitrator_areas'
import { IArbitratorTags } from '../../models/arbitrator_tags'

const SearchArbitrators: React.FC = () => {
  const { t } = useTranslation()
  const [searchVal, setSearchVal] = useState<string>("");
  const [countrySearchVal, setcountrySearchVal] = useState<string>("");
  const [specializationSearchVal, setspecializationSearchVal] = useState<string>("");
  const [regionSearchVal, setregionSearchVal] = useState<string>("");
  const [languagesSearchVal, setlanguagesSearchVal] = useState<string>("");
  const [arbitratorareaSearchVal, setarbitratorareaSearchVal] = useState<string>("");
  const [tagSearchVal, settagSearchVal] = useState<string>("");
  const [alldata, setallData] = useState([])
  const country_options: SelectProps['options'] = [];
  const specializations_options: SelectProps['options'] = [];
  const regions_options: SelectProps['options'] = [];
  const arbitrator_options: SelectProps['options'] = [];
  const arbitratorarea_options: SelectProps['options'] = [];
  const tag_options: SelectProps['options'] = [];

  const { urlValue, writeToUrl } = useUrlQueryParams({
    currentPage: 1,
    perPage: 10,
  });

  const { data: countries, } = useGetAllData<ICountries[]>({
    queryKey: ["countries"],
    url: "countries",
  });

  const { data: specializations, } = useGetAllData<ISpecialization[]>({
    queryKey: ["specializations"],
    url: "specializations",
  });

  const { data: regions, } = useGetAllData<IRegions[]>({
    queryKey: ["regions", countrySearchVal],
    url: "regions",
    urlParams: { 'country.id': countrySearchVal }
  });

  const { data: arbitrator_languages, } = useGetAllData<IArbitratorLanguages[]>({
    queryKey: ["arbitrator_languages"],
    url: "arbitrator_languages",
  });

  const { data: arbitrator_area, } = useGetAllData<IArbitratorAreas[]>({
    queryKey: ["arbitrator_areas"],
    url: "arbitrator_areas",
  });

  const { data: tags, } = useGetAllData<IArbitratorTags[]>({
    queryKey: ["tags"],
    url: "tags",
  });

  const { data: arbitrators } = useGetAllData<any>({
    queryKey: ["arbitrators", urlValue.perPage, urlValue.currentPage, searchVal, countrySearchVal, specializationSearchVal, regionSearchVal, languagesSearchVal, arbitratorareaSearchVal, tagSearchVal],
    url: "arbitrators",
    urlParams: { "perPage": urlValue.perPage, page: urlValue.currentPage, 'person.lastName': searchVal, counrty: countrySearchVal, arbitratorSpecialization: specializationSearchVal, region: regionSearchVal, arbitratorLanguages: languagesSearchVal, area: arbitratorareaSearchVal, tag: tagSearchVal },
    options: {
      refetchOnWindowFocus: false,
      retry: 1,
      onSuccess: (res: any) => {
        setallData(res);
      },
    },
  });

  countries?.map((item: any) => {
    country_options?.push({ label: item?.name, value: item?.id })
  })

  specializations?.map((item: any) => {
    specializations_options?.push({ label: item?.name, value: item?.id })
  })

  regions?.map((item: any) => {
    regions_options?.push({ label: item?.name, value: item?.id })
  })

  arbitrator_languages?.map((item: any) => {
    arbitrator_options?.push({ label: item?.name, value: item?.id })
  })

  arbitrator_area?.map((item: any) => {
    arbitratorarea_options?.push({ label: item?.name, value: item?.id })
  })

  tags?.map((item: any) => {
    tag_options?.push({ label: item?.name, value: item?.id })
  })


  const handleChange = (value: string[]) => {
    writeToUrl({ name: "countries", value: `${value}` })
    setcountrySearchVal(`${value}`)
  };

  const handlespecializationChange = (value: string[]) => {
    writeToUrl({ name: "specialization", value: `${value}` })
    setspecializationSearchVal(`${value}`)
  };

  const handleregionsChange = (value: string[]) => {
    writeToUrl({ name: "regions", value: `${value}` })
    setregionSearchVal(`${value}`)
  };

  const handlelanguagesChange = (value: string[]) => {
    writeToUrl({ name: "languages", value: `${value}` })
    setlanguagesSearchVal(`${value}`)
  };

  const handlearbitratorareaChange = (value: string[]) => {
    writeToUrl({ name: "arbitrator-area", value: `${value}` })
    setarbitratorareaSearchVal(`${value}`)
  };

  const handletagsChange = (value: string[]) => {
    writeToUrl({ name: "arbitrator-area", value: `${value}` })
    settagSearchVal(`${value}`)
  };


  return (
    <div className='container mx-auto'>
      <div className='pt-8'>
        <div className="grid lg:grid-cols-12 grid-cols-12 gap-4">
          <div className="lg:col-span-12 col-span-12">
            <SearchInput duration={500} setSearchVal={setSearchVal} placeholder={`${t('Search by name ...')}`} />
          </div>
          <div className='sm:col-span-6 col-span-12 grid grid-cols-12 gap-4 max-lg:border-r-2 max-lg:pr-4 max-sm:border-r-0 max-sm:pr-0'>
            <div className="lg:col-span-6 col-span-12 lg:border-r-2 lg:pr-4">
              <div className='mb-3'>
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: '100%', height: '44px' }}
                  placeholder={t('Select tags')}
                  onChange={handletagsChange}
                  options={tag_options}
                />
              </div>
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%', height: '44px' }}
                placeholder={t('Select country')}
                onChange={handleChange}
                options={country_options}
              />
            </div>
            <div className="lg:col-span-6 col-span-12 lg:border-r-2 lg:pr-4">
              <div className='mb-3'>
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: '100%', height: '44px' }}
                  placeholder={t('Select arbitrator area')}
                  onChange={handlearbitratorareaChange}
                  options={arbitratorarea_options}
                />
              </div>
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%', height: '44px' }}
                placeholder={t('Select specialization')}
                onChange={handlespecializationChange}
                options={specializations_options}
              />
            </div>
          </div>

          <div className='sm:col-span-6 col-span-12 grid grid-cols-12 gap-4'>
            <div className="lg:col-span-6 col-span-12 lg:border-r-2 lg:pr-4">
              <div className='mb-3'>
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: '100%', height: '44px' }}
                  placeholder={t('Select languages')}
                  onChange={handlelanguagesChange}
                  options={arbitrator_options}
                />
              </div>
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%', height: '44px' }}
                placeholder={t('Select regions')}
                onChange={handleregionsChange}
                options={regions_options}
              />
            </div>
            <div className='lg:col-span-6 col-span-12'>
              <Button htmlType='button' className='rounded-xl text-white text-center h-[44px] justify-center flex items-center bg-main_color w-full mb-3'><CiSearch size={24} color='white' className='mr-4' />{t('Search')}</Button>
              <Button htmlType='button' className='rounded-xl text-center h-[44px] justify-center flex items-center w-full border-1 border-main_color'><IoClose size={24} color='#29487E' className='mr-4' />{t('Close')}</Button>
            </div>
          </div>
        </div>

        <hr className='h-[3px] mt-12 bg-[#DAE8F0] rounded' />

        <div className='mt-6'>

          <div className='grid grid-cols-12 gap-3 mt-8'>
            <ArbitratorSearchResultCard data={arbitrators} />
            <div className="col-span-4 max-sm:col-span-12 mb-4">
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SearchArbitrators